__turbopack_context__.v({
  "bottomBar": "ProductPreview-module-scss-module__1I-a9q__bottomBar",
  "dialog": "ProductPreview-module-scss-module__1I-a9q__dialog",
  "hint": "ProductPreview-module-scss-module__1I-a9q__hint",
  "image": "ProductPreview-module-scss-module__1I-a9q__image",
  "toolbar": "ProductPreview-module-scss-module__1I-a9q__toolbar",
  "trigger": "ProductPreview-module-scss-module__1I-a9q__trigger",
  "viewport": "ProductPreview-module-scss-module__1I-a9q__viewport",
  "zoomed": "ProductPreview-module-scss-module__1I-a9q__zoomed",
});
